import { useEffect } from "react";
import { motion } from "framer-motion";
import Navbar from "../components/Navbar";
import MobileMenu from "../components/MobileMenu";
import Footer from "../components/Footer";
import StoryCard from "../components/StoryCard";
import { useJournal } from "../lib/usePortfolio";
import { useMeta } from "../lib/useMeta";

const EASE = [0.22, 1, 0.36, 1];

export default function Journal() {
  const { data, isLoading } = useJournal();
  const stories = data ?? [];
  useEffect(() => window.scrollTo(0, 0), []);
  useMeta("The Journal", "Featured weddings, told frame by frame — the light, the places and the quiet moments between.");

  return (
    <>
      <Navbar />
      <MobileMenu />
      <main data-testid="journal-page" className="pt-[72px]">
        <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-24 md:pt-32 pb-16">
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1, ease: EASE }}>
            <p className="text-[11px] font-mono tracking-[0.25em] uppercase text-stone-500">The Journal</p>
            <h1 className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl font-normal tracking-tight text-ivory leading-[1.05]">
              Stories of <span className="italic text-champagne">Unrepeatable</span> Days
            </h1>
            <p className="mt-6 max-w-xl text-sm sm:text-base font-light leading-relaxed text-stone-400">
              Featured weddings, told frame by frame — the light, the places and the quiet moments between.
            </p>
          </motion.div>
        </section>
        <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-32">
          {isLoading ? (
            <p data-testid="journal-loading" className="text-[11px] font-mono tracking-[0.3em] uppercase text-stone-500 animate-pulse">Turning the pages…</p>
          ) : stories.length === 0 ? (
            <p data-testid="journal-empty" className="font-serif text-2xl italic text-stone-500">The first story is being written. Return soon.</p>
          ) : (
            <div className="grid gap-12 lg:gap-16" data-testid="journal-list">
              <StoryCard story={stories[0]} large />
              {stories.length > 1 && (
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10">
                  {stories.slice(1).map((s, i) => <StoryCard key={s.id} story={s} index={i} />)}
                </div>
              )}
            </div>
          )}
        </section>
      </main>
      <Footer />
    </>
  );
}
